<template>
    <HelpButton @click="isShowDialog = true" />

    <!-- ヒント用のダイアログ -->
    <HelpDialog :isShow="isShowDialog" @close="isShowDialog = false" title="AnyTestとの連携情報について">
        <template v-slot:contents>
            <div>
                <h2>■ユーザ名とAPIキーの確認方法</h2>
                <p>
                    1. <a href="https://anytest.jp/login" target="_blank">AnyTestのご契約者様ページ</a>にログインする<br>
                    2. Profile画面を開く<br>
                    3. ユーザ名とAPIキーを確認する
                </p>
                <img src="@/assets/helps/HowToGetAnyTestAccount.png" alt="AnyTestInfo" width="900px">
            </div>
            <div>
                <h2>■デバイスIDの確認方法</h2>
                <p>
                    1. <a href="https://anytest.jp/login" target="_blank">AnyTestのご契約者様ページ</a>にログインする<br>
                    2. デバイス一覧画面を開く<br>
                    3. 使用したいデバイスの詳細画面を開く<br>
                    4. デバイスIDを確認する
                </p>
                <img src="@/assets/helps/HowToGetAnyTestDeviceId.png" alt="AnyTestDevice" width="900px">
            </div>
        </template>
    </HelpDialog>
</template>
<script>
import { ref } from 'vue'

export default {
    name: 'TestEnvHelp',
    setup() {

        // ###########
        // ダイアログ #
        // ###########
        const isShowDialog = ref(false)
        const updateDialog = (state) => {
            isShowDialog.value = state
        }

        return { updateDialog, isShowDialog }
    }
}
</script>
